import { useTranslation } from "react-i18next";

import { Grid, Typography } from "@mui/material";
import { FormikProps } from "formik";

import { ContentCard } from "../../../../../../content-card/ContentCard";
import { FormikTextField } from "../../../../../../formik/FormikTextField";
import { AssetInventoryMaxLength, AssetPersonalDataFormValues } from "../../AssetPersonalData.types";

interface Props {
  formik: FormikProps<AssetPersonalDataFormValues>;
}

export function CausesBlock({ formik }: Props) {
  const { t } = useTranslation();

  return (
    <ContentCard title={t("clients.client.debtSettlement.assetInventory.section1.causesTitle")}>
      <Typography variant="body2" color="text.secondary">
        {t("clients.client.debtSettlement.assetInventory.section1.causesHelpText")}
      </Typography>
      <Grid container rowSpacing={2} columnSpacing={2}>
        <Grid size={12}>
          <FormikTextField
            formik={formik}
            fieldName="causesDescription"
            label={t("clients.client.debtSettlement.assetInventory.section1.causesLabel")}
            multiline
            minRows={5}
            slotProps={{ input: { inputProps: { maxLength: AssetInventoryMaxLength.causesDescription } } }}
          />
        </Grid>
      </Grid>
    </ContentCard>
  );
}
